// import React, { useEffect, useState } from "react";
// import TherapyRoomCard from "./TherapyRoomCard";
// import Navbar from "../Navbar";
// import Footer from "../Footer";
// import beach from "../../assets/images/beach.png";
// import park from "../../assets/images/park.png";
// import { useNavigate } from "react-router-dom";

// function TestPage({ setCurrentNickname, currentNickname, handleLogout, setFormType, PlutonicuserID }) {
//   const navigate = useNavigate();

//   // Define test room details
//   const rooms = [
//     {
//       id: "test-park-therapy",
//       title: "Test Park Therapy Room",
//       description: "Testing room for the park.",
//       image: park,
//       available: true, // Always available
//       sessionStartTimeEST: "Always Available (Test Card)",
//       online: false, // Mock online status
//     },
//     {
//       id: "test-beach-therapy",
//       title: "Test Beach Therapy Room",
//       description: "Testing room for the beach.",
//       image: beach,
//       available: true, // Always available
//       sessionStartTimeEST: "Always Available (Test Card)",
//       online: false, // Mock online status
//     },
//   ];

//   const handleEnterClick = (roomType) => {
//     const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
//     if (!userId) {
//       alert("User ID is missing. Please log in again.");
//       return;
//     }

//     // Set a fixed meetingID for each test room
//     const testMeetingID = `${roomType}-fixed-meeting-id`;
//     sessionStorage.setItem("meetingID", testMeetingID);
//     sessionStorage.setItem("userId", userId);

//     console.log("[TestPage] sessionStorage - meetingID:", sessionStorage.getItem("meetingID"));
//   console.log("[TestPage] sessionStorage - userId:", sessionStorage.getItem("userId"));


//     const realRoomType = roomType.replace("test-", ""); // Remove "test-" prefix for Unity room mapping
//     navigate(`/unity-room/${realRoomType}`);
//   };

//   return (
//     <div>
//       <Navbar
//         setCurrentNickname={(nickname) => {
//           setCurrentNickname(nickname);
//           localStorage.setItem("currentNickname", nickname);
//         }}
//         currentNickname={currentNickname}
//         handleLogout={handleLogout}
//         setFormType={setFormType}
//         showButtons={true}
//         PlutonicuserID={PlutonicuserID || localStorage.getItem("PlutonicuserID")}
//       />
//       <div
//         className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
//         style={{
//           background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
//         }}
//       >
//         <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">
//           Your Virtual Spaces
//         </h2>
//         <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
//           {rooms.map((room) => (
//             <TherapyRoomCard
//               key={room.id}
//               image={room.image}
//               title={room.title}
//               description={room.description}
//               available={room.available}
//               sessionStartTimeEST={room.sessionStartTimeEST}
//               online={room.online}
//               onEnterClick={() => handleEnterClick(room.id)}
//             />
//           ))}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default TestPage;

import React, { useEffect } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";

const allowedUserIds = ["ST56UV78", "90QR12ST","34UV56WX","5CAFBPYH", "78YZ90AB","UFTBN1O1", "MN34OP56", "OP12QR34", "KL78MN90", "2D9BFUVY", "UV12WX34"]; // Whitelisted user IDs

function TestPage({ setCurrentNickname, currentNickname, handleLogout, setFormType, PlutonicuserID }) {
  const navigate = useNavigate();

  useEffect(() => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    console.log("[TestPage] Current User ID:", userId);

    if (!allowedUserIds.includes(userId)) {
      console.warn(`[TestPage] User ID (${userId}) is not allowed to access this page.`);
      navigate("/therapy-rooms"); // Redirect unauthorized users
    }
  }, [PlutonicuserID, navigate]);

  const rooms = [
    {
      id: "test-park-therapy",
      title: "Test Park Therapy Room",
      description: "Testing room for the park.",
      image: park,
      style: "Green Space",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-beach-therapy",
      title: "Test Beach Therapy Room",
      description: "Testing room for the beach.",
      image: beach,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-forest-therapy",
      title: "Test forest Therapy Room",
      description: "Testing room for the forest.",
      image: forest,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
  ];

  const handleEnterClick = (roomType) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }

    const testMeetingID = `${roomType}-fixed-meeting-id`;
    sessionStorage.setItem("meetingID", testMeetingID);
    sessionStorage.setItem("userId", userId);

    console.log("[TestPage] sessionStorage - meetingID:", sessionStorage.getItem("meetingID"));
    console.log("[TestPage] sessionStorage - userId:", sessionStorage.getItem("userId"));

    const realRoomType = roomType.replace("test-", "");
    navigate(`/unity-room/${realRoomType}`);
  };

  return (
    <div>
      <Navbar
        setCurrentNickname={(nickname) => {
          setCurrentNickname(nickname);
          localStorage.setItem("currentNickname", nickname);
        }}
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setFormType={setFormType}
        showButtons={true}
        PlutonicuserID={PlutonicuserID || localStorage.getItem("PlutonicuserID")}
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">Your Virtual Spaces</h2>
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              image={room.image}
              title={room.title}
              style={room.style}
              description={room.description}
              accessibility={room.accessibility}
              available={room.available}
              sessionStartTimeEST={room.sessionStartTimeEST}
              online={room.online}
              onEnterClick={() => handleEnterClick(room.id)}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TestPage;
